import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LoadingImg = styled.img`
    display: block;
    margin: auto;
`;

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: start;
`;

export const TitleText = styled.span`
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

export const Text = styled.span`
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    margin-top: 2px;
    margin-bottom: 4px;
`;

export const Icon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.colors.neutral300,
    width: 12,
    height: 12,
    fontSize: 12,
    lineHeight: 14,
    textAlign: 'center',
    marginBottom: 3,
    marginLeft: 4,
}));

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: end;
    gap: 4px;
`;